__turbopack_context__.v({
  "card": "OW0ZNW_card",
  "icon": "OW0ZNW_icon",
  "productCardSubtitle": "OW0ZNW_productCardSubtitle",
  "productCardTitle": "OW0ZNW_productCardTitle",
  "productCardWrapper": "OW0ZNW_productCardWrapper",
  "text": "OW0ZNW_text",
});
